<section class="content head">
  <div class="content-wrapper">
    <iaud-sid-title [sid]="sid"></iaud-sid-title>
    <iaud-audit-title [audit]="audit"></iaud-audit-title>
    <iaud-breadcrumb [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
    <iaud-sid-stepper *ngIf="sidId" [step]="2"></iaud-sid-stepper>
    <mat-card class="add-capa">
      <mat-card-title>New Capa</mat-card-title>
      <iaud-capa-edit-form #editFormComponent
        [capa]="capa" 
        [isNew]="true"
        [maxDate]="finding.dueDate"
        (isValidChange)="toggleFormValidity($event)">
      </iaud-capa-edit-form>

      <div class="add-capa__buttons">
        <button mat-raised-button class="right-margin" [routerLink]="cancelLink">Cancel</button>
        <button mat-raised-button
                class="right-margin"
                (click)="submitCapa(false)"
                [disabled]="!isFormValid">
          <mat-spinner *ngIf="isSavingLater$ | async" [diameter]="25"></mat-spinner>
          Save and Finish Later
        </button>
        <button mat-raised-button
                class="right-margin"
                (click)="submitCapa(true)"
                [disabled]="!isFormValid">
          <mat-spinner *ngIf="isSaving$ | async" [diameter]="25"></mat-spinner>
          Ready To Submit
        </button>
      </div>
    </mat-card>
  </div>
</section>
